import { useEffect, useState } from "react";
import { Card, CardBody, CardHeader } from "../../../components/card/card";
import HeaderContent from "./HeaderContenr";
import GeneralContent from "./generalContent";
import ResumeContent from "./resumeContent";
import ParticipantContent from "./participantContent";
import { dataTel1DeleteEvt, dataTel3DelEvt, dataTel3GetDetail } from "../../../config/apiSPA";
import { useNavigate, useParams } from "react-router-dom";
import ModalConfirm from "../../../components/modal/modalConfirm";
import ModalInfo from "../../../components/modal/modalInfo";

function Tel3Detail() {
  const { id } = useParams();
  const [mainData, setMainData] = useState(null);
  const [modalDeleteEvt, setModalDeleteEvt] = useState({ show: false, id: null });
  const [modalInfoDanger, setModalInfoDanger] = useState({ show: false, text: "" });
  const navigate = useNavigate();

  const loadingData = async () => {
    const res = await dataTel3GetDetail(id);
    setMainData(res.data);
  };
  const handleClickDeleteEvent = () => {
    setModalDeleteEvt({ show: true, id: id });
  };
  const handleClickDeleteConfirm = async () => {
    try {
      setModalDeleteEvt((a) => ({ ...a, show: false }));
      const res = await dataTel3DelEvt(id);
      console.log(res);
      navigate("/training-evaluation-3/event");
    } catch (error) {
      setModalInfoDanger({ show: true, text: `We’re having trouble processing your request right now : ${error.message}` });
    }
  };
  useEffect(() => {
    loadingData();
  }, []);
  return (
    <>
      <HeaderContent />
      <div className="row gx-4">
        <div className="col-lg-6">{mainData ? <GeneralContent data={mainData} /> : ""}</div>
        <div className="col-lg-6">
          <ResumeContent id={id} />
        </div>
        <div className="col-lg-12">{mainData ? <ParticipantContent data={mainData} /> : ""}</div>
      </div>
      <a onClick={handleClickDeleteEvent} href="#/" className="text-danger">
        Delete
      </a>
      <ModalConfirm clicked={handleClickDeleteConfirm} onHide={() => setModalDeleteEvt((a) => ({ ...a, show: false }))} show={modalDeleteEvt.show} title={"Warning !!"} text={"Are you sure want to delete this event?"} theme={"danger"} />
      <ModalInfo
        onHide={() => setModalInfoDanger((a) => ({ ...a, show: false }))}
        clicked={() => setModalInfoDanger((a) => ({ ...a, show: false }))}
        show={modalInfoDanger.show}
        title={"Failed !!"}
        text={modalInfoDanger.text}
        theme={"danger"}
      />
    </>
  );
}
export default Tel3Detail;
